import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 11L5.90321 7.09679C5.95519 7.04481 6.04057 7.04869 6.08763 7.10515L8.41645 9.89974C8.462 9.9544 8.54392 9.96007 8.59657 9.91221L14 5M14 5V9M14 5H10"
      stroke="#6FCF97"
      stroke-linecap="round"
    />
  </svg>
);
